import React from 'react'
import Datalist from 'components/Datalist'
import { useGroupsData, useRemoveGroupMember } from '@modmd/data'
import { DEVICE, RADIUS } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import Card from 'components/Card'
import Button from 'components/Button'
import Pagination from 'components/Pagination'
import Icon from 'components/Icon'

export interface Params {
  userId: string
}

const GROUPS_PAGE_LENGTH = 10
const SKELETON_COLUMNS_GROUPS = 3

export const GroupsUser = ({ userId }: Params) => {
  const isDesktop = useIsMinDevice(DEVICE.DESKTOP)
  const [groupsPage, setGroupsPage] = React.useState(1)
  const groupsQuery = useGroupsData({
    filter: { memberUserIds: [userId] },
    page: groupsPage,
    membersFilter: {
      id: userId,
    },
    membersPageLength: 1,
    pageLength: GROUPS_PAGE_LENGTH,
  })
  const {
    handleRemoveGroupMember,
    isLoadingRemoveGroupMember,
    isRefetching: areGroupsRefetching,
  } = useRemoveGroupMember()

  const groupCount = groupsQuery?.data?.groups?.pagination.total ?? 0
  const pageLength = groupsQuery?.data?.groups?.pagination.length ?? 0

  return (
    <>
      <Card borderRadius={`0 0 ${RADIUS.RADIUS_5} ${RADIUS.RADIUS_5}`} paddingBottom={5}>
        <Datalist
          isLoading={groupsQuery.loading || areGroupsRefetching}
          data={groupsQuery.data?.groups?.Groups || []}
          skeletonProps={{
            columns: SKELETON_COLUMNS_GROUPS,
            rows: GROUPS_PAGE_LENGTH,
          }}
          shouldRenderTableHeader={isDesktop}
          renderTableHeader={() => (
            <Datalist.Row gridTemplateColumns="repeat(4, 1fr)">
              <Datalist.HeaderCell label="Name" />
              <Datalist.HeaderCell label="Role" />
              <Datalist.HeaderCell label="Company" />
              <Datalist.HeaderCell label="Action" />
            </Datalist.Row>
          )}
          renderTableRow={({ name, Members, Company, id }) => {
            const member = Members?.Members.find(({ User }) => User.id === userId)
            return (
              <Datalist.Row gridTemplateColumns="repeat(4, 1fr)">
                <Datalist.Cell label="Name">{name}</Datalist.Cell>
                <Datalist.Cell label="Role">{member?.role || 'N/A'}</Datalist.Cell>
                <Datalist.Cell label="Company">{Company?.name}</Datalist.Cell>
                <Datalist.Cell label="Actions">
                  <Button
                    size="small"
                    isFetching={isLoadingRemoveGroupMember}
                    onClick={() => {
                      void handleRemoveGroupMember({
                        groupId: id,
                        userId: member?.User?.id ?? '',
                        refetchQuery: groupsQuery.refetch,
                      })
                    }}
                    appearance="ghost"
                    colorVariant="danger"
                  >
                    <Icon.Trash />
                  </Button>
                </Datalist.Cell>
              </Datalist.Row>
            )
          }}
        />
      </Card>
      <>
        {groupCount > pageLength && (
          <Pagination.Wrapper>
            <Pagination
              firstPage={1}
              lastPage={Math.ceil(groupCount / pageLength)}
              currentPage={
                Math.ceil((groupsQuery?.data?.groups?.pagination?.from ?? 0) / pageLength) + 1
              }
              onPageChange={setGroupsPage}
            />
          </Pagination.Wrapper>
        )}
      </>
    </>
  )
}
